import React from 'react'
import { Chip } from '@mui/material'
import { TableHeaderConfigWithType } from '../../../components/_EOS/Table'
import { ICreateDun } from '../../../interfaces/StockKeepingUnitDun/StockKeepingUnitDun'
import { TypePackage } from '../entities/Product'

export type CustomActionsProps = {
  id: number
  row: ICreateDun
}

export const generateTableHeadersProduct = (
  typepackages: TypePackage[] | undefined
) => {
  const tableHeadersProduct: TableHeaderConfigWithType<ICreateDun>[] = [
    {
      field: 'dun',
      title: 'DUN',
      sortable: false
    },
    {
      field: 'quantity',
      title: 'Cantidad',
      sortable: false
    },
    {
      field: 'description',
      title: 'Descripción',
      sortable: false
    },
    {
      field: 'typePackageId',
      title: 'Unidad de Medida',
      sortable: false,
      formater: (value: unknown) =>
        typepackages?.find((el) => el.typePackageId === (value as number))
          ?.name || ''
    },
    {
      field: 'isDefault',
      title: 'Predeterminado',
      sortable: false,
      formater: (active: unknown) => setIconState(active as boolean)
    }
  ]

  return tableHeadersProduct
}

const setIconState = (active: boolean) => {
  return (
    <Chip
      size='small'
      label={active ? 'Sí' : 'No'}
      sx={{
        backgroundColor: active ? '#4caf50' : '#e0e0e0',
        color: active ? '#fff' : 'rgba(0,0,0,0.87)',
        fontWeight: 600,
        fontSize: '0.72rem',
        borderRadius: '20px',
        height: '22px',
        minWidth: '40px'
      }}
    />
  )
}
